// src/stores/map/hooks/useClearFacilityMap.ts
//
// Logic hook replacing the Redux `clearFacilityMap` thunk.
// Returns a stable callback that sets `txnId.facilityId` to CLEAR_MAP_ID
// when the current facilityId differs — no-ops otherwise.
import { useCallback } from "react";

import { CLEAR_MAP_ID } from "constants/app.constants";

import { useMapStore } from "../mapStore";

/**
 * Returns a function that clears the facility portion of the map result.
 *
 * The guard prevents redundant store writes when the facility map is
 * already cleared, preserving the same semantics as the original Redux
 * thunk in `mapSlice.ts`.
 */
export function useClearFacilityMap(): () => void {
  const setTxnId = useMapStore((s) => s.setTxnId);

  return useCallback(() => {
    const txnId = useMapStore.getState().txnId;
    if (txnId.facilityId === CLEAR_MAP_ID) return;
    setTxnId({ ...txnId, facilityId: CLEAR_MAP_ID });
  }, [setTxnId]);
}
